<template>
	<div class="cloud-progressManagement">

		<div class="cloud-progressManagement-title"
			style="width: 98%; height: calc(180 / 1080 * 100vh); margin-top: calc(12.5vh); margin-left: 1%; ">
			<div class="cloud-progressManagement-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
				<p>智能工序写实管理</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-progressManagement-title-content" style="overflow-y: hidden;">
				<div class="cloud-progressManagement-top">
					工点：
					<el-select v-model="form.accesstype" placeholder="请选择" class="elInputSelect">
						<el-option v-for="item in tunnelOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="cloud-progressManagement-top-content">
					<p class="pLable">施工地点：</p>
					<p>咏思隧道出口</p>
					<p class="pLable">区段里程：</p>
					<p>DK89+730-DK86+799</p>
					<p class="pLable">区段长度：</p>
					<p>2931.00mm</p>
					<p class="pLable">施工日期：</p>
					<p style="width: calc(605 / 1920 * 100vh); margin-top: 0.5vh;"><el-date-picker v-model="value1"
							type="date" placeholder="选择日期"></el-date-picker></p>
					<p class="pLable">循环工序：</p>
					<p style="width: calc(505 / 1920 * 100vh);">IV级围岩 进尺1.6-2.4mm 三台阶法</p>
				</div>
			</div>
		</div>

		<div class="cloud-progressManagement-title"
			style="width: 98%; height: calc(300 / 1080 * 100vh); margin-top: calc(31.5vh); margin-left: 1%; ">
			<div class="cloud-progressManagement-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
				<p>第1循环</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-progressManagement-title-content" style="overflow-y: hidden;">
				<div class="cloud-progressManagement-title-content-table" style="margin-top: 3vh;">
					<p style="color: #fff; width: 5%;">序号</p>
					<p style="color: #fff; width: 10%;">工序名称</p>
					<p style="color: #fff; width: 8%;">考核时长</p>
					<p style="color: #fff; width: 6%;">起始时间</p>
					<p style="color: #fff; width: 6%;">结束时间</p>
					<p style="color: #fff; width: 6%;">实际用时</p>
					<p style="color: #fff; width: 15%;">节超（超时-分钟）</p>
					<p style="color: #fff; width: 15%;">衔接时长</p>
					<p style="color: #fff; width: 15%;">影响原因</p>
				</div>
				<div class="scroll-container">
					<ul class="scroll-list">
						<li class="cloud-progressManagement-title-content-table" v-for="(item, index) in 110"
							:key="index">
							<p>{{ index }}</p>
							<p>34min</p>
							<p>12 : 24 : 00</p>
							<p>12 : 24 : 00</p>
							<p>1h 30min</p>
							<p>22</p>
							<p>--</p>
							<p>--</p>
							<p>--</p>
						</li>
					</ul>
				</div>
				<div style="margin-top: 2vh; margin-left: 1%;">单循环耗时：20h 30min</div>
			</div>
		</div>

		<div class="cloud-progressManagement-title"
			style="width: 98%; height: calc(360 / 1080 * 100vh); margin-top: calc(61.5vh); margin-left: 1%; ">
			<div class="cloud-progressManagement-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
				<p>进度产值分析</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-progressManagement-title-content" style="overflow-y: hidden;">
				<div id="chart_total_days" ref="chart_total_days" style="width: 100%; height: 30vh; margin-top: 2vh;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import { tunnelProgress } from '@/public/api.js'

// 引入路由实例
export default {
	name: 'progressManagement',
	components: {
	},
	data() {
		return {
			myChart_GasDay: null,
			TunnelsData: [],
			form: {
				accesstype: ''
			},
			tunnelOptions: [],
			startTime: 1704067200000, // 2024-01-01 00:00:00 时间戳（毫秒）
			// categoriesData：Y 轴分类（如隧道断面、工作面等）
			categoriesData: ['钻爆', '出渣', '支护', '喷浆'],
			// dataLIst：X 轴标签（可选，用于 axisLabel.formatter）
			dataLIst: [
				{ name: '2025-01' },
				{ name: '2025-02' },
				{ name: '2025-03' },
				{ name: '2025-04' },
				{ name: '2025-05' },
				{ name: '2025-06' }
			],
			// seriesData 格式：[yIndex, startTime, endTime, value3, value4]
			// 示例：[0, 1704067200000, 1706745600000, 120, 80]
			seriesData: [
				[0, 1704067200000, 1706745600000, 120, 80],   // 左线
				[3, 1706745600000, 1709251200000, 150, 30], // 左线第二段（无安全步距）
				[1, 1704067200000, 1709251200000, 130, 90],   // 右线
				[2, 1705276800000, 1707955200000, 90, 60]     // 辅助通道
			]
		}
	},
	computed: {

	},
	mounted() {
		let that = this;
		that.TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));

		this.initChart();
		// 监听窗口大小变化，自动调整图表
		window.addEventListener('resize', this.handleResize);
		this.getTunnelProgress();
	},
	methods: {
		getTunnelProgress() {
			let that = this;
			tunnelProgress({ itemId: that.TunnelsData.itemId }).then(res => {
				if (res.data.code == 200) {
					res.data.data.forEach((item, index) => {
						that.tunnelOptions.push({
							value: item.tunnelNumber,
							label: item?.tunnelName
						});
					});
				}
			})
		},
		renderItem(params, api) {
			const categoryIndex = api.value(0); // y 轴索引
			const start = api.coord([api.value(1), categoryIndex]); // 起始 x 坐标
			const end = api.coord([api.value(2), categoryIndex]);   // 结束 x 坐标
			const height = 20;
			let value3 = api.value(3);
			let value4 = api.value(4);

			const rectShape = echarts.graphic.clipRectByRect(
				{
					x: start[0],
					y: start[1] - height / 2,
					width: end[0] - start[0],
					height: height
				},
				{
					x: params.coordSys.x,
					y: params.coordSys.y,
					width: params.coordSys.width,
					height: params.coordSys.height
				}
			);

			if (!rectShape) return;

			// 设置进度条颜色
			let color = '#0EB35D'; // 默认颜色

			// 返回矩形和文本
			return {
				type: 'group',
				children: [{
					type: 'rect',
					shape: rectShape,
					style: {
						fill: color
					}
				}, {
					type: 'text',
					style: {
						text: `${value3} mm${value4 !== null ? ` (${value4}mm)` : ''}`,
						textAlign: 'center',
						fill: '#FFFFFF', // 文本颜色
						fontSize: 12,
						fontFamily: 'Arial',
					},
					position: [start[0] + (end[0] - start[0]) / 2, start[1] - height / 2 + 5]
				}]
			};
		},

		initChart() {
			const chartDom = this.$refs.chart_total_days;
			this.myChart = echarts.init(chartDom);

			const option = {
				tooltip: {
					formatter: (params) => {
						if (params.value[4] === null || params.value[4] === undefined) {
							return (
								params.marker +
								params.name +
								': ' +
								params.value[3] +
								' mm'
							);
						} else {
							return (
								params.marker +
								params.name +
								': ' +
								params.value[3] +
								' mm  安全步距：' +
								params.value[4] +
								'mm'
							);
						}
					}
				},
				title: {
					left: 'center',
					textStyle: {
						color: '#FFFFFF'
					}
				},
				dataZoom: [
					// 	{
					// 		type: 'slider',
					// 		filterMode: 'weakFilter',
					// 		showDataShadow: false,
					// 		top: 10,
					// 		labelFormatter: ''
					// 	},
					// 	{
					// 		type: 'inside',
					// 		filterMode: 'weakFilter'
					// 	}
					{
						type: 'inside',
						filterMode: 'weakFilter'
					}
				],
				grid: {
					height: 150,
					top: 60,
					bottom: 80
				},
				xAxis: {
					min: this.startTime,
					scale: true,
					type: 'time',
					axisLabel: {
						formatter: (val, index) => {
							// 注意：这里不能直接用 dataLIst[index]，因为 index 是刻度索引，不是数据索引
							// 更安全的做法是格式化时间
							return echarts.time.format(val, '{yyyy}-{MM}', false);
						},
						textStyle: {
							color: '#FFFFFF'
						}
					},
					nameTextStyle: {
						color: '#FFFFFF',
						fontSize: 14,
						fontWeight: 'bold'
					}
				},
				yAxis: {
					data: this.categoriesData,
					nameTextStyle: {
						color: '#FFFFFF',
						fontSize: 14,
						fontWeight: 'bold'
					},
					axisLabel: {
						textStyle: {
							color: '#FFFFFF'
						}
					}
				},
				series: [
					{
						type: 'custom',
						renderItem: this.renderItem,
						itemStyle: {
							opacity: 1
						},
						encode: {
							x: [1, 2],
							y: 0
						},
						data: this.seriesData
					}
				]
			};

			this.myChart.setOption(option);
		},
		// 窗口大小变化时调整图表
		handleResize() {
			if (this.myChart_GasDay) {
				this.myChart_GasDay.resize();
			}
			if (this.myChart_GasHoury) {
				this.myChart_GasHoury.resize();
			}
		},
	},
	beforeDestroy() {
		// 移除事件监听，销毁图表
		window.removeEventListener('resize', this.handleResize);
		if (this.myChart_GasDay) {
			this.myChart_GasDay.dispose();
		}
		if (this.myChart_GasHoury) {
			this.myChart_GasHoury.dispose();
		}
	}
}
</script>
<style scoped>
/* 引入字体 */
@font-face {
	font-family: 'DS-Digital';
	src: url('../font/DS-DIGIB.TTF') format('truetype');
	font-weight: normal;
	font-style: normal;
}

.cloud-progressManagement {
	width: 100%;
	height: 100%;
	text-align: left;

	.cloud-progressManagement-title {
		position: absolute;
		top: 1vh;
		left: 0;
		width: 100%;
		height: calc(920 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;

		.cloud-progressManagement-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: 100%;
				height: auto;
				margin: 0;
				padding: 0;
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
			}
		}

		.cloud-progressManagement-title-content {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: calc(870 / 1080 * 100vh);
			margin: 0;
			padding: 0;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
		}
	}

	.cloud-progressManagement-top {
		width: 98%;
		height: calc(55 / 1080 * 100vh);
		margin-top: 3vh;
		margin-left: 1%;
		background: url(@/assets/images/progressManagement_bj.png);
		background-size: 100% 100%;
		position: relative;

		>img {
			width: 20px;
			height: auto;
			margin: 0;
			padding: 0;
			position: absolute;
			top: 1.5vh;
			left: 2.5vh;
		}
	}


	::v-deep .elInputSelect {
		border: none !important;
		padding: 2px !important;
		background-color: transparent !important;
		width: 300px !important;
		margin: 10px;
		margin-left: 2vw;
		margin-top: 0vh;
	}

	::v-deep .elInputSelect .el-input__inner {
		background-color: transparent !important;
		border: 0px solid #3585b3;
		color: #fff;
	}

	::v-deep .elInputSelect .el-input-group__append {
		background-color: transparent !important;
		border: 0px solid #3585b3;
	}

	::v-deep .el-input__inner {
		background-color: #082435 !important;
		border: 0px solid #3585b3 !important;
	}

	::v-deep .el-form-item {
		margin-bottom: 0px;
	}

	.cloud-progressManagement-title-content-ul-progressManagement {
		list-style: none;
		margin: 0;
		padding: 0;

		>li {
			position: relative;
			margin: 0;
			padding: 0;
			text-align: left;
			float: left;
			width: calc(25% - 2vw);
			height: calc(100 / 1080 * 100vh);
			margin: 0;
			padding: 0;

			>img {
				width: 4vw !important;
				height: 8vh !important;
				margin: 0;
				padding: 0;
				position: absolute;
				top: 4vh;
				left: 0.5vw;
				float: left;
			}

			>div {
				position: absolute;
				top: 4.5vh;
				left: 5.5vw;
				width: 60%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;

				>p {
					margin: 0;
					padding: 0;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 0.8rem;
					font-style: normal;
					text-transform: none;
				}

				>p:nth-child(1) {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 0.8rem;
					color: #EBFF36;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-bottom: 0.6vh;

					>span {
						font-family: DS-Digital, DS-Digital;
						font-weight: 400;
						font-size: 2.2rem !important;
						color: #dfef05;
						font-style: normal;
						text-transform: none;
						padding-right: 0.5vw;
					}
				}
			}
		}
	}

	.cloud-progressManagement-title-content-table {
		width: 100%;
		height: 2.5vh;
		margin: 0;
		padding: 0;
		margin-top: 1vh;
		text-align: center;

		>p {
			height: 2.5vh;
			margin: 0;
			padding: 0;
			float: left;
			line-height: 2.5vh;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.9rem;
			color: rgba(255, 255, 255, 0.6);
			text-align: center;
			font-style: normal;
			text-transform: none;
		}

		>p:nth-child(1) {
			width: 5%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(2) {
			width: 11%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(3) {
			width: 9%;
		}

		>p:nth-child(4) {
			width: 6%;
		}

		>p:nth-child(5) {
			width: 6%;
		}

		>p:nth-child(6) {
			width: 6%;
		}

		>p:nth-child(7) {
			width: 15%;
		}

		>p:nth-child(8) {
			width: 15%;
		}

		>p:nth-child(9) {
			width: 15%;
		}

	}

	.scroll-container {
		width: 93%;
		height: 14vh;
		overflow-y: auto;
		scrollbar-width: thin;
		scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
		list-style: none;
		padding: 0;
		margin: 0;
	}

	/* 滚动列表：包裹所有项并执行动画 */
	::v-deep .scroll-list {
		margin: 0;
		padding: 0;
		list-style: none;
		animation: scrollUp 100s linear infinite;
		/* 滚动动画 */
	}

	/* 鼠标悬停暂停动画 */
	.scroll-container:hover .scroll-list {
		animation-play-state: paused;
	}

	.cloud-progressManagement-top-content {
		width: 98%;
		height: calc(55 / 1080 * 100vh);
		margin-top: 0.5vh;
		margin-left: 1%;
		background-size: 100% 100%;
		position: relative;

		>p {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.9rem;
			color: #fff;
			text-align: left;
			font-style: normal;
			text-transform: none;
			float: left;
			width: calc(505 / 1920 * 100vh);
		}

		>.pLable {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.9rem;
			color: #fff;
			text-align: center;
			font-style: normal;
			text-transform: none;
			float: left;
			width: calc(155 / 1920 * 100vh);
		}
	}
}
</style>